
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexyiMr4HThNoQK6SNmdMF_45isJga5jHpgoUX4YfxKJsFlwMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/index.vue?macro=true";
import { default as _91id_93oOa9f51AdAOzVzfFUm15PjQ2qaNWobAaztbX0s077L0Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/live/[id].vue?macro=true";
import { default as loginhttmRVIf5VXp2PLFxhlWVpq4_zq4UHfAR0BX42AY4ZQMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/login.vue?macro=true";
import { default as indexHBmfpJtf9ZoiJnsfzmgdvy1EEI9o2ClY7MLVVZOsxL4Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/index.vue?macro=true";
import { default as Lobby8QDRyemDYb67YRB_1lRIdFfBNi7bLgXVmjRZJGtqbPMMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/Lobby.vue?macro=true";
import { default as usersrlCv4Ct3cggbEWAEJzS_45SQ6RWmfh03GqDLcsTEJTKqAMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/admin/users.vue?macro=true";
import { default as indexN4_45B3XUrLTrAiLBjd6FKNZlH8Dihjh_45a_45qYQF2wXxPsMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/index.vue?macro=true";
import { default as register_dc7dC_453ide_458iF_45vfh_45pPXeIJ6_sFehxQAqw_5j7r4Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/register.vue?macro=true";
import { default as indexJ3sWuqHgfMMxfcnK_vbvVGItCFo4ABFptwovDg9UxEYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/index.vue?macro=true";
import { default as _91event_93JU4_45E8Azu9IKwbf2ofFs7gq2Kv0q7hcr88_NS9I2zgkMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/events/[event].vue?macro=true";
import { default as privacy_45policy4edfW4MARGmOSi2t9wOFtTQPzDgJBGqHicwadO9bcFgMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/privacy-policy.vue?macro=true";
import { default as my_45statsvyIjIJSKv3NYZ_45NYPnK6Q2lwjyv3G9UTgLtxeVHuGEcMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-stats.vue?macro=true";
import { default as settingsTQE9hNRaTk3nttwXUn15LybXkPDb7bfI6uZMZGVy6usMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/settings.vue?macro=true";
import { default as terms_45of_45servicey777uAbtzfaaX8fgYjyVPSoPeeRz01ITHxFEnO6t0kYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/terms-of-service.vue?macro=true";
import { default as index65luyRFNAP2_45KneC_vKnctlj9LoBJnX0PIvrUrQ7FGYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/index.vue?macro=true";
import { default as my_45matchesOWeNjf7B_45qD5XjH50J96Tvz73m3XFoiCafNZfw43ubYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-matches.vue?macro=true";
import { default as reset_45passwordAzkVyrXmEnlCufruWl5onunO3Tm5HE7voxAjFUZ7b5QMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/reset-password.vue?macro=true";
import { default as offline_46clientzMA3bPwpuD4HW2ou0OjgfDqxOAQtSM44B7IFMlHxyEsMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/offline.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/home/runner/work/dartsspace/dartsspace/node_modules/.pnpm/nuxt@3.17.1_@capacitor+preferences@7.0.1_@capacitor+core@7.2.0__@netlify+blobs@8.2.0_@parcel+_iovcdhcvmsceb6pj4vmkrghb3i/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as indexQs4F3VDKwimtUBvflhEupd_458mxrYjDWSvnWooVSLSTYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/index.vue?macro=true";
import { default as statsxqlSGUcQ61WMeasR0u9Q_45NX8CeyjqUKRwEeTvTWNaScMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/stats.vue?macro=true";
import { default as index_46clientDIUwGR_45biceSE6QfQ0B9GkWRxhY6JJhZ9A0EHw_6tasMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tablet/index.client.vue?macro=true";
import { default as login_46clientjsqMR7I7r0A6O_zHVPoPrRumjtR12P61dCmJvDo8B5cMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tablet/login.client.vue?macro=true";
import { default as createYxsOEQS_45VbxZGLEGY8XKRL_5k5jCsypRpKHT2mYEuHkMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/create.vue?macro=true";
import { default as _91id_93_46client38BZNjMhT0Lohj2vGzxdQUVNJPU9LjQCjGwVEqZVB9cMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/bot/[id].client.vue?macro=true";
import { default as indexloDa2HH6YEV4kEin__45ZsKIAEE_45fyVehN5r_456RhG0OPIMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/index.vue?macro=true";
import { default as createVsovG0Z89WGKChLgZUGfC2iypqJ6vnJXdWBM9hfyf1kMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/create.vue?macro=true";
import { default as my_45tournamentsJ27pYzUnstbkc4eG5fJmXaKEk_45CzfVIpyztup4EOrQEMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-tournaments.vue?macro=true";
import { default as indexnge9_457UuGJx6Y9gv5UKgva8hEH26bOOhPRIFYJxz1eoMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/competition/match/index.vue?macro=true";
import { default as events_45locationshkxOzpLv2s348z6UDKp286bqANeNotcUlqQOWrw0r8cMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events-locations.vue?macro=true";
import { default as edit6royBP1YjFSqo_4545Wb4s1abES7BBJyluw_bQAMpQUaoMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/edit.vue?macro=true";
import { default as indexnwuRf3FBg2whLHFqNdrs4w5simYl4ENAjpV0hHunIFIMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/index.vue?macro=true";
import { default as playersKqclGB2zwSUS0yefvbK65h_b54ZV18aWIsTDvX_455R_45kMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/players.vue?macro=true";
import { default as listj6BfHJ7hg_459E5AtnsHdiUVcIDsVh0x406SVBpDxUVzcMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue?macro=true";
import { default as groups_455hxJIXeKtXdlY9LLkJHEHOdtQxXv8Q88YyQYiUCOYMMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue?macro=true";
import { default as resultsZPeelm2RpEiACKH3BfEn4ePe5kr23TcoQh9HVBPuIe0Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue?macro=true";
import { default as losers_45koUOhYi8LeJ5sssaqYVZWfFR6t_45W_ml2QX0fx7wkkD9qIMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue?macro=true";
import { default as winners_45koE6YArYUQc4QAgur_i64_45yYT0BL7HABZDXDH00zhqLa8Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue?macro=true";
import { default as _91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id].vue?macro=true";
import { default as _91id_93_46clientTyW9U52EPCSBSYt06KPbEVsztOxdysOBZ0yRrz2_wcoMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/online/[id].client.vue?macro=true";
import { default as _91id_93cItRNRLh4CZhtM6DiXxpUT_YWgmdjefGYJ5eiliOxFcMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/game/[id].vue?macro=true";
import { default as indexyAgmgxR0EA7dlAc7AT6Er1tkap_45VWIRAbSY2tFyzqb4Meta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/index.vue?macro=true";
import { default as _91id_93d81gsIneHnFnx6tyQDcJzV3Hi4GGgn6zHLgtmoN_45WwEMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/[id].vue?macro=true";
import { default as index3ow5pb91T1K_b3nGh_qGbJmafYQ7U0fP2Y6BMKxpwoUMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/index.vue?macro=true";
import { default as indexm6vqFgF_uVebySMyvBMUgIBRao3RjhLAbzJiwjcPDlIMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/[game]/index.vue?macro=true";
import { default as gamessYWvVSLEIRO8e0z7OO0irlW10N_45fVrvUnmw7pCK1kyQMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games.vue?macro=true";
import { default as indexGtgx9qwxQVNem7tPZInGmuT5FzT0bDH_KQESCUvSeEUMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/index.vue?macro=true";
import { default as groupsX5lh0FoaKR6U5yfNaiDKlXnRR8rnexyQspPL4OaHP0EMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/groups.vue?macro=true";
import { default as resultsFgJvumzUmskwpAKRtvmzHilkSrBkjmPUHL1Lw_pXhYAMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/results.vue?macro=true";
import { default as winner_45bracketsEYbMhl_WF_cIE0q5wFxh6Rq4tFu_45WC_LfXmuyFzTcxcMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue?macro=true";
import { default as consolation_45bracketsDi8ndv4eOl9wHltOZrgMTzYBTA27Uc_45anrYv6SpJYykMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue?macro=true";
import { default as _91tournament_93I_45HNZX_45tiDWdQD4tT5e2toOtDqvkMTBArvHsG3DQyaYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament].vue?macro=true";
import { default as boardsGHDQWmQyvlZOA2uNWiVgreQn_45QoxI32XKGWC01zuGZYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/boards.vue?macro=true";
import { default as indexhtulcGdOnvaYS4lLLlXhE0fDLb5iK9044bbjp17_45aEUMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/participants/index.vue?macro=true";
import { default as edita_1gw5k255FI_I7VnGX1a5I__OBX_45_AHvTjxrl_45ZtwUMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/edit.vue?macro=true";
import { default as createx4kdjDr99_nthv_45_45NLGsRliTWXT9_45paXAQS3OyCEUVwMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/create.vue?macro=true";
import { default as indexBuOzlp2nO9ToJx52k7ZpcB65btr8ldPMoaazvXU7_7sMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/index.vue?macro=true";
import { default as indextuZV9Q7dAXJKEocA3V3IkE5WLao_45AwDiGJEpH85RPaUMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/index.vue?macro=true";
import { default as my_45coachksEIhqM1cA2fii_459xzHHy1i_45yMSBmlYzd0h2ZgjqVEsMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-coach.vue?macro=true";
import { default as my_45studentsRMTYGoB_viIZhZNA12GMB9cx9uZyR2l_45aFjZbzjRK9oMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-students.vue?macro=true";
import { default as _91id_93k0hteJZBXPdiprO8paoqeDtCf_45Vw0JiuUOwp7bIqEdYMeta } from "/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/student/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/index.vue")
  },
  {
    name: "index___nl",
    path: "/nl",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/index.vue")
  },
  {
    name: "live-id___en",
    path: "/en/live/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/live/[id].vue")
  },
  {
    name: "live-id___nl",
    path: "/nl/live/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/live/[id].vue")
  },
  {
    name: "live-id___de",
    path: "/de/live/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/live/[id].vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: { ...(loginhttmRVIf5VXp2PLFxhlWVpq4_zq4UHfAR0BX42AY4ZQMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___nl",
    path: "/nl/auth/login",
    meta: { ...(loginhttmRVIf5VXp2PLFxhlWVpq4_zq4UHfAR0BX42AY4ZQMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/login.vue")
  },
  {
    name: "auth-login___de",
    path: "/de/auth/login",
    meta: { ...(loginhttmRVIf5VXp2PLFxhlWVpq4_zq4UHfAR0BX42AY4ZQMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/login.vue")
  },
  {
    name: "play___en",
    path: "/en/play",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/index.vue")
  },
  {
    name: "play___nl",
    path: "/nl/play",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/index.vue")
  },
  {
    name: "play___de",
    path: "/de/play",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/index.vue")
  },
  {
    name: "play-Lobby___en",
    path: "/en/play/Lobby",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/Lobby.vue")
  },
  {
    name: "play-Lobby___nl",
    path: "/nl/play/Lobby",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/Lobby.vue")
  },
  {
    name: "play-Lobby___de",
    path: "/de/play/Lobby",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/Lobby.vue")
  },
  {
    name: "admin-users___en",
    path: "/en/admin/users",
    meta: {"middleware":["superadmin"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/admin/users.vue")
  },
  {
    name: "admin-users___nl",
    path: "/nl/admin/users",
    meta: {"middleware":["superadmin"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/admin/users.vue")
  },
  {
    name: "admin-users___de",
    path: "/de/admin/users",
    meta: {"middleware":["superadmin"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/admin/users.vue")
  },
  {
    name: "manage___en",
    path: "/en/manage",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/index.vue")
  },
  {
    name: "manage___nl",
    path: "/nl/manage",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/index.vue")
  },
  {
    name: "manage___de",
    path: "/de/manage",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/index.vue")
  },
  {
    name: "auth-register___en",
    path: "/en/auth/register",
    meta: { ...(register_dc7dC_453ide_458iF_45vfh_45pPXeIJ6_sFehxQAqw_5j7r4Meta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___nl",
    path: "/nl/auth/register",
    meta: { ...(register_dc7dC_453ide_458iF_45vfh_45pPXeIJ6_sFehxQAqw_5j7r4Meta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/register.vue")
  },
  {
    name: "auth-register___de",
    path: "/de/auth/register",
    meta: { ...(register_dc7dC_453ide_458iF_45vfh_45pPXeIJ6_sFehxQAqw_5j7r4Meta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/register.vue")
  },
  {
    name: "profile___en",
    path: "/en/profile",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/index.vue")
  },
  {
    name: "profile___nl",
    path: "/nl/profile",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/index.vue")
  },
  {
    name: "profile___de",
    path: "/de/profile",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/index.vue")
  },
  {
    name: "events-event___en",
    path: "/en/events/:event()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/events/[event].vue")
  },
  {
    name: "events-event___nl",
    path: "/nl/events/:event()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/events/[event].vue")
  },
  {
    name: "events-event___de",
    path: "/de/events/:event()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/events/[event].vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___nl",
    path: "/nl/privacy-policy",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___de",
    path: "/de/privacy-policy",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/privacy-policy.vue")
  },
  {
    name: "profile-my-stats___en",
    path: "/en/profile/my-stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-stats.vue")
  },
  {
    name: "profile-my-stats___nl",
    path: "/nl/profile/my-stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-stats.vue")
  },
  {
    name: "profile-my-stats___de",
    path: "/de/profile/my-stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-stats.vue")
  },
  {
    name: "profile-settings___en",
    path: "/en/profile/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/settings.vue")
  },
  {
    name: "profile-settings___nl",
    path: "/nl/profile/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/settings.vue")
  },
  {
    name: "profile-settings___de",
    path: "/de/profile/settings",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/settings.vue")
  },
  {
    name: "terms-of-service___en",
    path: "/en/terms-of-service",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___nl",
    path: "/nl/terms-of-service",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/terms-of-service.vue")
  },
  {
    name: "terms-of-service___de",
    path: "/de/terms-of-service",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/terms-of-service.vue")
  },
  {
    name: "tournaments___en",
    path: "/en/tournaments",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___nl",
    path: "/nl/tournaments",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/index.vue")
  },
  {
    name: "tournaments___de",
    path: "/de/tournaments",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/index.vue")
  },
  {
    name: "profile-my-matches___en",
    path: "/en/profile/my-matches",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-matches.vue")
  },
  {
    name: "profile-my-matches___nl",
    path: "/nl/profile/my-matches",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-matches.vue")
  },
  {
    name: "profile-my-matches___de",
    path: "/de/profile/my-matches",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-matches.vue")
  },
  {
    name: "auth-reset-password___en",
    path: "/en/auth/reset-password",
    meta: { ...(reset_45passwordAzkVyrXmEnlCufruWl5onunO3Tm5HE7voxAjFUZ7b5QMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___nl",
    path: "/nl/auth/reset-password",
    meta: { ...(reset_45passwordAzkVyrXmEnlCufruWl5onunO3Tm5HE7voxAjFUZ7b5QMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/reset-password.vue")
  },
  {
    name: "auth-reset-password___de",
    path: "/de/auth/reset-password",
    meta: { ...(reset_45passwordAzkVyrXmEnlCufruWl5onunO3Tm5HE7voxAjFUZ7b5QMeta || {}), ...{"middleware":["anonymous"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/auth/reset-password.vue")
  },
  {
    name: "play-offline___en",
    path: "/en/play/offline",
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/offline.client.vue"))
  },
  {
    name: "play-offline___nl",
    path: "/nl/play/offline",
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/offline.client.vue"))
  },
  {
    name: "play-offline___de",
    path: "/de/play/offline",
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/offline.client.vue"))
  },
  {
    name: "play-training___en",
    path: "/en/play/training",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/index.vue")
  },
  {
    name: "play-training___nl",
    path: "/nl/play/training",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/index.vue")
  },
  {
    name: "play-training___de",
    path: "/de/play/training",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/index.vue")
  },
  {
    name: "play-training-stats___en",
    path: "/en/play/training/stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/stats.vue")
  },
  {
    name: "play-training-stats___nl",
    path: "/nl/play/training/stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/stats.vue")
  },
  {
    name: "play-training-stats___de",
    path: "/de/play/training/stats",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/stats.vue")
  },
  {
    name: "tablet",
    path: "/tablet",
    meta: { ...(index_46clientDIUwGR_45biceSE6QfQ0B9GkWRxhY6JJhZ9A0EHw_6tasMeta || {}), ...{"middleware":["board-auth"]} },
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tablet/index.client.vue"))
  },
  {
    name: "tablet-login",
    path: "/tablet/login",
    meta: { ...(login_46clientjsqMR7I7r0A6O_zHVPoPrRumjtR12P61dCmJvDo8B5cMeta || {}), ...{"middleware":["board-anonymous"]} },
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tablet/login.client.vue"))
  },
  {
    name: "manage-events-create___en",
    path: "/en/manage/events/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/create.vue")
  },
  {
    name: "manage-events-create___nl",
    path: "/nl/manage/events/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/create.vue")
  },
  {
    name: "manage-events-create___de",
    path: "/de/manage/events/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/create.vue")
  },
  {
    name: "play-bot-id___en",
    path: "/en/play/bot/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/bot/[id].client.vue"))
  },
  {
    name: "play-bot-id___nl",
    path: "/nl/play/bot/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/bot/[id].client.vue"))
  },
  {
    name: "play-bot-id___de",
    path: "/de/play/bot/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/bot/[id].client.vue"))
  },
  {
    name: "manage-rankings___en",
    path: "/en/manage/rankings",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/index.vue")
  },
  {
    name: "manage-rankings___nl",
    path: "/nl/manage/rankings",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/index.vue")
  },
  {
    name: "manage-rankings___de",
    path: "/de/manage/rankings",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/index.vue")
  },
  {
    name: "manage-rankings-create___en",
    path: "/en/manage/rankings/create",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/create.vue")
  },
  {
    name: "manage-rankings-create___nl",
    path: "/nl/manage/rankings/create",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/create.vue")
  },
  {
    name: "manage-rankings-create___de",
    path: "/de/manage/rankings/create",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/create.vue")
  },
  {
    name: "profile-my-tournaments___en",
    path: "/en/profile/my-tournaments",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-tournaments.vue")
  },
  {
    name: "profile-my-tournaments___nl",
    path: "/nl/profile/my-tournaments",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-tournaments.vue")
  },
  {
    name: "profile-my-tournaments___de",
    path: "/de/profile/my-tournaments",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/profile/my-tournaments.vue")
  },
  {
    name: "competition-match",
    path: "/competition/match",
    meta: indexnge9_457UuGJx6Y9gv5UKgva8hEH26bOOhPRIFYJxz1eoMeta || {},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/competition/match/index.vue")
  },
  {
    name: "manage-events-locations___en",
    path: "/en/manage/events-locations",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events-locations.vue")
  },
  {
    name: "manage-events-locations___nl",
    path: "/nl/manage/events-locations",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events-locations.vue")
  },
  {
    name: "manage-events-locations___de",
    path: "/de/manage/events-locations",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events-locations.vue")
  },
  {
    name: "manage-events-id-edit___en",
    path: "/en/manage/events/:id()/edit",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/edit.vue")
  },
  {
    name: "manage-events-id-edit___nl",
    path: "/nl/manage/events/:id()/edit",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/edit.vue")
  },
  {
    name: "manage-events-id-edit___de",
    path: "/de/manage/events/:id()/edit",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/edit.vue")
  },
  {
    name: _91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta?.name,
    path: "/en/manage/tournaments/:id()",
    meta: { ...(_91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id].vue"),
    children: [
  {
    name: "manage-tournaments-id___en",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "manage-tournaments-id-players___en",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "manage-tournaments-id-play-list___en",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "manage-tournaments-id-play-groups___en",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "manage-tournaments-id-play-results___en",
    path: "play/results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "manage-tournaments-id-play-losers-ko___en",
    path: "play/losers-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "manage-tournaments-id-play-winners-ko___en",
    path: "play/winners-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  }
]
  },
  {
    name: _91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta?.name,
    path: "/nl/manage/tournaments/:id()",
    meta: { ...(_91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id].vue"),
    children: [
  {
    name: "manage-tournaments-id___nl",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "manage-tournaments-id-players___nl",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "manage-tournaments-id-play-list___nl",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "manage-tournaments-id-play-groups___nl",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "manage-tournaments-id-play-results___nl",
    path: "play/results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "manage-tournaments-id-play-losers-ko___nl",
    path: "play/losers-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "manage-tournaments-id-play-winners-ko___nl",
    path: "play/winners-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  }
]
  },
  {
    name: _91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta?.name,
    path: "/de/manage/tournaments/:id()",
    meta: { ...(_91id_93gcZToYkPtHmdMqhnsl_45EGtKi3ffH3EeedWm9YZ0tV_450Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id].vue"),
    children: [
  {
    name: "manage-tournaments-id___de",
    path: "",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/index.vue")
  },
  {
    name: "manage-tournaments-id-players___de",
    path: "players",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/players.vue")
  },
  {
    name: "manage-tournaments-id-play-list___de",
    path: "play/list",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/list.vue")
  },
  {
    name: "manage-tournaments-id-play-groups___de",
    path: "play/groups",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/groups.vue")
  },
  {
    name: "manage-tournaments-id-play-results___de",
    path: "play/results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/results.vue")
  },
  {
    name: "manage-tournaments-id-play-losers-ko___de",
    path: "play/losers-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/losers-ko.vue")
  },
  {
    name: "manage-tournaments-id-play-winners-ko___de",
    path: "play/winners-ko",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/[id]/play/winners-ko.vue")
  }
]
  },
  {
    name: "play-online-id___en",
    path: "/en/play/online/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/online/[id].client.vue"))
  },
  {
    name: "play-online-id___nl",
    path: "/nl/play/online/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/online/[id].client.vue"))
  },
  {
    name: "play-online-id___de",
    path: "/de/play/online/:id()",
    meta: {"middleware":["auth"]},
    component: () => createClientPage(() => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/online/[id].client.vue"))
  },
  {
    name: "play-training-game-id___en",
    path: "/en/play/training/game/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/game/[id].vue")
  },
  {
    name: "play-training-game-id___nl",
    path: "/nl/play/training/game/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/game/[id].vue")
  },
  {
    name: "play-training-game-id___de",
    path: "/de/play/training/game/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/game/[id].vue")
  },
  {
    name: "manage-tournaments___en",
    path: "/en/manage/tournaments",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/index.vue")
  },
  {
    name: "manage-tournaments___nl",
    path: "/nl/manage/tournaments",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/index.vue")
  },
  {
    name: "manage-tournaments___de",
    path: "/de/manage/tournaments",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/index.vue")
  },
  {
    name: "play-training-games-id___en",
    path: "/en/play/training/games/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/[id].vue")
  },
  {
    name: "play-training-games-id___nl",
    path: "/nl/play/training/games/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/[id].vue")
  },
  {
    name: "play-training-games-id___de",
    path: "/de/play/training/games/:id()",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/[id].vue")
  },
  {
    name: _91tournament_93I_45HNZX_45tiDWdQD4tT5e2toOtDqvkMTBArvHsG3DQyaYMeta?.name,
    path: "/en/tournaments/:tournament()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament].vue"),
    children: [
  {
    name: gamessYWvVSLEIRO8e0z7OO0irlW10N_45fVrvUnmw7pCK1kyQMeta?.name,
    path: "games",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games.vue"),
    children: [
  {
    name: "tournaments-tournament-games___en",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/index.vue")
  },
  {
    name: "tournaments-tournament-games-game___en",
    path: ":game()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/[game]/index.vue")
  }
]
  },
  {
    name: "tournaments-tournament___en",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "tournaments-tournament-groups___en",
    path: "groups",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "tournaments-tournament-results___en",
    path: "results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "tournaments-tournament-winner-brackets___en",
    path: "winner-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "tournaments-tournament-consolation-brackets___en",
    path: "consolation-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  }
]
  },
  {
    name: _91tournament_93I_45HNZX_45tiDWdQD4tT5e2toOtDqvkMTBArvHsG3DQyaYMeta?.name,
    path: "/nl/tournaments/:tournament()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament].vue"),
    children: [
  {
    name: gamessYWvVSLEIRO8e0z7OO0irlW10N_45fVrvUnmw7pCK1kyQMeta?.name,
    path: "games",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games.vue"),
    children: [
  {
    name: "tournaments-tournament-games___nl",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/index.vue")
  },
  {
    name: "tournaments-tournament-games-game___nl",
    path: ":game()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/[game]/index.vue")
  }
]
  },
  {
    name: "tournaments-tournament___nl",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "tournaments-tournament-groups___nl",
    path: "groups",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "tournaments-tournament-results___nl",
    path: "results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "tournaments-tournament-winner-brackets___nl",
    path: "winner-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "tournaments-tournament-consolation-brackets___nl",
    path: "consolation-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  }
]
  },
  {
    name: _91tournament_93I_45HNZX_45tiDWdQD4tT5e2toOtDqvkMTBArvHsG3DQyaYMeta?.name,
    path: "/de/tournaments/:tournament()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament].vue"),
    children: [
  {
    name: gamessYWvVSLEIRO8e0z7OO0irlW10N_45fVrvUnmw7pCK1kyQMeta?.name,
    path: "games",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games.vue"),
    children: [
  {
    name: "tournaments-tournament-games___de",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/index.vue")
  },
  {
    name: "tournaments-tournament-games-game___de",
    path: ":game()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/games/[game]/index.vue")
  }
]
  },
  {
    name: "tournaments-tournament___de",
    path: "",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/index.vue")
  },
  {
    name: "tournaments-tournament-groups___de",
    path: "groups",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/groups.vue")
  },
  {
    name: "tournaments-tournament-results___de",
    path: "results",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/results.vue")
  },
  {
    name: "tournaments-tournament-winner-brackets___de",
    path: "winner-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/winner-brackets.vue")
  },
  {
    name: "tournaments-tournament-consolation-brackets___de",
    path: "consolation-brackets",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/tournaments/[tournament]/consolation-brackets.vue")
  }
]
  },
  {
    name: "manage-events-id-boards___en",
    path: "/en/manage/events/:id()/boards",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/boards.vue")
  },
  {
    name: "manage-events-id-boards___nl",
    path: "/nl/manage/events/:id()/boards",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/boards.vue")
  },
  {
    name: "manage-events-id-boards___de",
    path: "/de/manage/events/:id()/boards",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/events/[id]/boards.vue")
  },
  {
    name: "manage-participants___en",
    path: "/en/manage/participants",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/participants/index.vue")
  },
  {
    name: "manage-participants___nl",
    path: "/nl/manage/participants",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/participants/index.vue")
  },
  {
    name: "manage-participants___de",
    path: "/de/manage/participants",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/participants/index.vue")
  },
  {
    name: "manage-rankings-id-edit___en",
    path: "/en/manage/rankings/:id()/edit",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/edit.vue")
  },
  {
    name: "manage-rankings-id-edit___nl",
    path: "/nl/manage/rankings/:id()/edit",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/edit.vue")
  },
  {
    name: "manage-rankings-id-edit___de",
    path: "/de/manage/rankings/:id()/edit",
    meta: {"middleware":"auth"},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/edit.vue")
  },
  {
    name: "manage-tournaments-create___en",
    path: "/en/manage/tournaments/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/create.vue")
  },
  {
    name: "manage-tournaments-create___nl",
    path: "/nl/manage/tournaments/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/create.vue")
  },
  {
    name: "manage-tournaments-create___de",
    path: "/de/manage/tournaments/create",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/tournaments/create.vue")
  },
  {
    name: "play-training-games___en",
    path: "/en/play/training/games",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/index.vue")
  },
  {
    name: "play-training-games___nl",
    path: "/nl/play/training/games",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/index.vue")
  },
  {
    name: "play-training-games___de",
    path: "/de/play/training/games",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/games/index.vue")
  },
  {
    name: "manage-rankings-id___en",
    path: "/en/manage/rankings/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/index.vue")
  },
  {
    name: "manage-rankings-id___nl",
    path: "/nl/manage/rankings/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/index.vue")
  },
  {
    name: "manage-rankings-id___de",
    path: "/de/manage/rankings/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/manage/rankings/[id]/index.vue")
  },
  {
    name: "play-training-coaching-my-coach___en",
    path: "/en/play/training/coaching/my-coach",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-coach.vue")
  },
  {
    name: "play-training-coaching-my-coach___nl",
    path: "/nl/play/training/coaching/my-coach",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-coach.vue")
  },
  {
    name: "play-training-coaching-my-coach___de",
    path: "/de/play/training/coaching/my-coach",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-coach.vue")
  },
  {
    name: "play-training-coaching-my-students___en",
    path: "/en/play/training/coaching/my-students",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-students.vue")
  },
  {
    name: "play-training-coaching-my-students___nl",
    path: "/nl/play/training/coaching/my-students",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-students.vue")
  },
  {
    name: "play-training-coaching-my-students___de",
    path: "/de/play/training/coaching/my-students",
    meta: {"middleware":["auth"]},
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/my-students.vue")
  },
  {
    name: "play-training-coaching-student-id___en",
    path: "/en/play/training/coaching/student/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/student/[id].vue")
  },
  {
    name: "play-training-coaching-student-id___nl",
    path: "/nl/play/training/coaching/student/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/student/[id].vue")
  },
  {
    name: "play-training-coaching-student-id___de",
    path: "/de/play/training/coaching/student/:id()",
    component: () => import("/home/runner/work/dartsspace/dartsspace/packages/frontend/app/pages/play/training/coaching/student/[id].vue")
  }
]